<template>
    <div class="order_summary">
        <div class="ui basic buttons" v-if="show_buttons && is_printing">
            <div class="ui loading button">
                <i class="print icon"></i>
                <!-- 列印託運總表 -->
                {{ $t('ui.toolbox.operation_summary.print_operation_list') }}
            </div>
        </div>
        <div class="ui basic buttons" v-if="show_buttons && !is_printing">
            <div class="ui button" @click="print">
                <i class="print icon"></i>
                <!-- 列印託運總表 -->
                {{ $t('ui.toolbox.operation_summary.print_operation_list') }}
            </div>
        </div>

        <div v-show="show_contents">
            <div ref="printable" style="padding: 25px;">
                <h2 class="ui center aligned header">
                    <img :src="logo_url">
                    <div class="content">
                        {{ title }}({{ customer_service_hotline }})
                        <div class="sub header">{{ sub_title }}</div>
                    </div>
                </h2>
                <table class="ui celled center aligned table">
                    <thead>
                        <tr>
                            <!--
                                原單號
                                運單號
                                收件人姓名
                                收件人電話
                                收件人地址
                                付款方式
                                重量
                                代收貨款
                            -->
                            <th>{{ $t("models.attributes.core_waybills.original_number") }}</th>
                            <th>{{ $t("models.attributes.core_waybills.number") }}</th>
                            <th>{{ $t("models.attributes.core_waybills.tracking_number") }}</th>
                            <th>{{ $t("models.attributes.core_waybills.consignee") }}</th>
                            <th>{{ $t("models.attributes.core_waybills.consignee_phone") }}</th>
                            <th>{{ $t("models.attributes.core_waybills.consignee_address") }}</th>
                            <th>{{ $t("models.attributes.core_waybills.payment_type") }}</th>
                            <th>{{ $t("models.attributes.core_waybills.weight_in_kilo") }}</th>
                            <th>{{ $t("models.attributes.core_waybills.collection") }}</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="core_waybill in core_waybills">
                            <td>{{ core_waybill.original_number }}</td>
                            <td>{{ core_waybill.number }}</td>
                            <td>{{ core_waybill.tracking_number }}</td>
                            <td>{{ core_waybill.consignee_name }}</td>
                            <td>{{ core_waybill.consignee_phone }}</td>
                            <td>{{ core_waybill.consignee_address }}</td>
                            <td>{{ core_waybill.payment_type }}</td>
                            <td>{{ core_waybill.weight_in_kilo }}</td>
                            <td>{{ core_waybill.collection }}</td>
                        </tr>
                    </tbody>
                </table>

                <table class="ui celled center aligned table">
                    <tbody>
                        <tr>
                            <td class="collapsing">
                                <!-- 寄件人簽名 -->
                                {{ $t('ui.toolbox.operation_summary.table.sender_signature') }}
                            </td>
                            <td class="seven width column"></td>
                            <td class="collapsing">
                                <!-- 收貨司機簽名 -->
                                {{ $t('ui.toolbox.operation_summary.table.driver_signature') }}
                            </td>
                            <td class="seven width column"></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ToolOrderSummaryMain",
    props: {
        show_buttons: {
            type: Boolean,
            default: false,
        },
        show_contents: {
            type: Boolean,
            default: false,
        },
        assigned_core_waybills: {
            type: Array,
            default() {
                return []
            }
        },
        logo_url: {
            type: String,
            default: '/images/tw568_logo.png'
        },
        force_location: String,
        title: String,
        sub_title: String,
        customer_service_hotline: String,
        logistician: Object,
        blank_value_text: {
            type: String,
            default: "-",
        },
        channel_name: {
            type: String,
            default: 'order_summary',
        },
        default_search_params: {
            type: Object,
            default() {
                return {}
            }
        },
        scope: String,
    },
    data() {
        return {
            is_printing: false,
            core_waybills: [],
        }
    },
    mounted() {
        // print channel
        this.$bus.$off(this.channel_name)
        this.$bus.$on(this.channel_name, () => {
            this.print()
        })
    },
    computed: {
    },
    methods: {
        async print() {
            if (!this.is_printing) {
                await new Promise(resolve => {
                    this.is_printing = true
                    this.core_waybills = this.assigned_core_waybills
                    resolve()
                })
                if (this.core_waybills.length == 0) {
                    await this.fetch_core_waybills()
                }
                // 初始化列印空間
                await new Promise(resolve => {
                    $("div#print").html("")
                    resolve()
                })
                await this.$nextTick(() => {
                    window.Noty.closeAll()
                })
                // 等待列印內容轉錄至列印空間
                await new Promise(resolve => {
                    $(this.$refs.printable).clone().appendTo('div#print')
                    resolve()
                })
                // 呼叫列印視窗
                await new Promise(resolve => {
                    window.print()
                    this.is_printing = false
                    resolve()
                })
            }
        },
        fetch_core_waybills() {
            switch (this.scope) {
                case "provider":
                    var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_core_waybills_filter).parse(
                        {},
                        "?" + object_to_query(this.default_search_params)
                    )
                    var token = localStorage.getItem("authentication_token")
                    break
                case "customer":
                    var url = new RestUrl(this.$store.state.customer.routes.api_v1_customer_core_waybills_filter).parse(
                        {},
                        "?" + object_to_query(this.default_search_params)
                    )
                    var token = localStorage.getItem("customer_authentication_token")
                    break
            }

            return axios.get(url, {headers: { Authorization: token }})
            .then(response => {
                if (response.data.status == "success") {
                    this.core_waybills = response.data.core_waybills
                } else if (response.data.status == "failure") {
                    // this.$noty.error("抓取運單失敗")
                    this.$noty.error(
                        this.$t('ui.notifications.error.fetch__name', {
                            name: this.$t('models.core_waybills'),
                            reason: ': ' + response.data.errors
                        })
                    )
                }
                return response
            })
            .catch(error => {
                // this.errors.push("抓取運單失敗" + this.$t('ui.general.network_abnormality')+": "+ error.response.status)
                this.errors.push(
                    this.$t('ui.notifications.error.fetch__name', {
                        name: this.$t('models.core_waybills'),
                        reason: ': ' +this.$t('ui.general.network_abnormality')+','+ error.response.status
                    })
                )
                return Promise.reject(error)
            })
            .then(() => {
            })
        },
    },
    components: {
    }
}
</script>

<style scoped>
table {
    border-color:  black !important;
}
table td, th{
    border-color:  black !important;
}
</style>
